// DESCRIPTION: Entry point for the frontend event calendar React app.
// Mounts CalendarApp into every .nb-event-calendar element on the page.

import React from 'react';
import ReactDOM from 'react-dom/client';
import '../../css/event-calendar.css';
import CalendarApp from '../components/calendar/CalendarApp';

document.addEventListener( 'DOMContentLoaded', function () {
	const containers = document.querySelectorAll( '.nb-event-calendar' );
	containers.forEach( function ( container ) {
		const root = ReactDOM.createRoot( container );
		root.render(
			<CalendarApp
				initialView={ container.dataset.view || '' }
				initialCategories={ container.dataset.categories || '' }
				initialTags={ container.dataset.tags || '' }
				showFilters={ container.dataset.showFilters !== 'false' }
				availableViews={ container.dataset.views || '' }
				eventType={ container.dataset.eventType || '' }
				showToolbar={ container.dataset.showToolbar !== 'false' }
				weekStartsOn={ container.dataset.weekStartsOn || '' }
				eventsPerCell={ container.dataset.eventsPerCell || '' }
			/>
		);
	} );
} );
